export const flowLoginZH = {
  flowLogin1: '账号安全',
  flowLogin2: '找回密码',
  flowLogin3: '安全验证',
  flowLogin4: '设置新密码',
  flowLogin5: '设置成功',
  flowLogin6: '重置密码成功！',
  flowLogin7: '现在您可以正常使用我们的平台了~',
  flowLogin8: '下一步',
  flowLogin9: '重置密码',
  flowLogin10: '立即登录',
  flowLogin11: '获取验证码',
  flowLogin12: '后重新获取',
  flowLogin13: '请输入6-16位登录密码',
  flowLogin14: '忘记密码',
  flowLogin15: '请输入手机号/邮箱',
  flowLogin16: '请输入图形验证码',
  flowLogin17: '请输入验证码',
  flowLogin18: '请输入6-16位新密码',
  flowLogin19: '请再次确认6-16位新密码',
  flowLogin20: '完成',
  flowLogin21: '邮箱验证码已经发送至你的邮箱，请进入邮箱查看。',
  flowLogin22: '我知道了',
  flowLogin23: '密码修改成功',
  flowLogin24: '登录',
  flowLogin25: '该账号不存在',
  flowLogin26: '请设置登录密码以完成注册流程',
  flowLogin27: '注册',
  flowLogin28: '请再次输入登录密码',
  flowLogin29: '注册账号',
  flowLogin30: '忘记密码？',
  flowLogin31: '短信登录',
  flowLogin32: '手机号一键登录',
  flowLogin33: '阅读并同意',
  flowLogin34: '《用户协议》',
  flowLogin35: '《隐私政策》',
  flowLogin36: '《儿童用户协议》',
  flowLogin37: '《儿童隐私政策》',
  flowLogin38: '登录中...',
  flowLogin39: '登录成功',
  flowLogin40: '取消授权',
  flowLogin41: '正在登录...',
  flowLogin42: '请先完成注册！',
  flowLogin43: '两次密码不一致',
  flowLogin44: '请输入6-16位密码',
  flowLogin45: '请输入手机号',
  flowLogin46: '请填写正确格式的手机号！',
  flowLogin47: '请填写正确格式的邮箱！',
  flowLogin48: '请填写完整信息！',
  flowLogin49: '新密码和确认密码不一致！',
  flowLogin50: '密码长度未满5位',
  flowLogin51: '学而不思则罔，思而不学则殆',
  flowLogin52: '未登录',
  flowLogin53: '登录/注册',
  flowLogin54: '为了账号安全， 请先验证当前手机号:',
  flowLogin55: '为了账号安全， 请先验证当前邮箱:',
  flowLogin56: '请输入旧密码',
  flowLogin57: '请输入新密码',
  flowLogin58: '请重新输入新密码',
  flowLogin59: '请输入图形验证码',
  flowLogin60: '请输入验证码！',
  flowLogin61: '请输入请填写正确格式的手机号！',
  flowLogin62: '请输入请填写正确格式的邮箱！',
  flowLogin63: '更换手机',
  flowLogin64: '更换邮箱',
  flowLogin65: '修改密码',
  flowLogin66: '两次输入的密码不一致',
  flowLogin67: '新密码',
  flowLogin68: '确认密码',
  flowLogin69: '请再次输入新密码',
  flowLogin70: '和 ',
  flowLogin71: '新密码和确认密码不一致!',
  flowLogin72: '重新获取验证码',
  flowLogin73: '重新发送',
  flowLogin74: '已发送6位数验证码至',
  flowLogin75: '登 录',
  flowLogin76: '请输入短信验证码！',
  flowLogin77: '提交失败,请重试!',
  flowLogin78: '更换成功！',
  flowLogin79: '确认',
  flowLogin80: '两次输入密码不一致！',
  flowLogin81: '请再次输入密码',
  flowLogin82: '请输入密码',
  flowLogin83: ''
}

export const flowLoginEN = {
  flowLogin1: 'Account Security',
  flowLogin2: 'Password Recovery',
  flowLogin3: 'Security Verification',
  flowLogin4: 'Set a new password',
  flowLogin5: 'Setup Successful',
  flowLogin6: 'Reset password successful!',
  flowLogin7: 'Now you can use our platform normally~',
  flowLogin8: 'Next',
  flowLogin9: 'Reset password',
  flowLogin10: 'Login now',
  flowLogin11: 'Get CAPTCHA',
  flowLogin12: ' to resend',
  flowLogin13: '6-16 digit password',
  flowLogin14: 'Forgot password',
  flowLogin15: 'Phone number/email',
  flowLogin16: 'Graphical CAPTCHA',
  flowLogin17: 'Enter the CAPTCHA',
  flowLogin18: 'Please enter a new password of 6-16 digits',
  flowLogin19: 'Reconfirm new password',
  flowLogin20: 'Complete',
  flowLogin21: 'The verification code has been sent to your email, please check your inbox.',
  flowLogin22: 'I see',
  flowLogin23: 'Password changed successfully',
  flowLogin24: 'Log In',
  flowLogin25: 'The account does not exist',
  flowLogin26: 'Please set a login password to complete the registration process',
  flowLogin27: 'Sign Up',
  flowLogin28: 'Re-enter password',
  flowLogin29: 'Register account',
  flowLogin30: 'Forgot your password?',
  flowLogin31: 'SMS login',
  flowLogin32: 'Phone number one-click login',
  flowLogin33: 'Read and agree',
  flowLogin34: '《User Agreement》',
  flowLogin35: '《Privacy Policy》',
  flowLogin36: `《Children's User Agreement》`,
  flowLogin37: `《Children's Privacy Policy》`,
  flowLogin38: 'Logining in...',
  flowLogin39: 'Login success',
  flowLogin40: 'Cancel authorization',
  flowLogin41: 'Logging in...',
  flowLogin42: 'Please complete registration first! ',
  flowLogin43: 'Passwords don’t match',
  flowLogin44: 'Please enter 6-16 digits password',
  flowLogin45: 'Please enter your mobile phone number',
  flowLogin46: 'Please fill in the correct format of mobile phone number!',
  flowLogin47: 'Please fill in the correct email!',
  flowLogin48: 'Please fill in the complete information! ',
  flowLogin49: 'New password and confirmation password do not match!',
  flowLogin50: 'Password length less than 5 characters',
  flowLogin51: 'Study without thinking leads into a trap. Thinking without study leads into a jeopardy',
  flowLogin52: 'Not logged in',
  flowLogin53: 'Log In / Sign Up',
  flowLogin54: 'For account security, please first verify the current mobile phone number',
  flowLogin55: 'For account security, please verify the current email',
  flowLogin56: 'Please enter the old password',
  flowLogin57: 'Please enter a new password',
  flowLogin58: 'Please re-enter the new password',
  flowLogin59: 'Graphical CAPTCHA',
  flowLogin60: 'Enter the verification code',
  flowLogin61: 'Please fill in the correct format of mobile phone number! ',
  flowLogin62: 'Please fill in the correct email !',
  flowLogin63: 'Mobile phone replacement',
  flowLogin64: 'Change mailbox',
  flowLogin65: 'Change password',
  flowLogin66: 'The passwords entered twice do not match',
  flowLogin67: 'New password',
  flowLogin68: 'Confirm password',
  flowLogin69: 'Re-enter the new password',
  flowLogin70: 'and ',
  flowLogin71: 'New password and confirmation password do not match!',
  flowLogin72: 'Retrieve CAPTCHA',
  flowLogin73: 'resent',
  flowLogin74: 'A 6-digit verification code has been sent to',
  flowLogin75: 'sign in',
  flowLogin76: 'Please enter the SMS verification code!',
  flowLogin77: 'Submission failed, please try again! Please try again!',
  flowLogin78: 'Changed successfully!',
  flowLogin79: 'Confirm',
  flowLogin80: 'The passwords entered twice do not match!',
  flowLogin81: 'Please enter the password again',
  flowLogin82: 'Please enter the password',
  flowLogin83: 'After'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/login.js